/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import { Tab, Nav } from "react-bootstrap";
import requireAuth from "components/hoc/requireAuth";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { getProfileGeneral } from "actions";
// import CareerPath from "./CareerPath";
// import CompetencyAndInterviewResults from "./CompetencyAndInterviewResults";
import ExamResults from "./ExamResults";
import TrainingScores from "./TrainingScores";
import "./employee360.css";

class Employee360Container extends Component {
  state = {
    currentTab: "#tab3",
  };

  componentDidMount() {
    if (Object.keys(this.props.generalProfile).length === 0) {
      this.props.getProfileGeneral(
        () => this.props.onProcessBegin(),
        (result) => {
          this.props.onProcessEnd();
        },
        (error) => {
          this.props.onProcessEnd();
          console.log(error);
        }
      );
    }
  }

  renderTabbedContent = () => {
    if (Object.keys(this.props.generalProfile).length === 0) {
      return null;
    }

    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <Tab.Container
          id="nav-tab"
          defaultActiveKey="#tab1"
          activeKey={this.state.currentTab}
        >
          <nav className="scrollNav">
            <Nav variant="tabs" role="tablist">
              {/* <Nav.Item>
                <Nav.Link
                  onClick={() => this.setState({ currentTab: "#tab1" })}
                  eventKey="#tab1"
                >
                  <span className="icon-icon-menu-personal mr-1"></span>
                  <Trans>employee360_careerpath</Trans>
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  onClick={() => this.setState({ currentTab: "#tab2" })}
                  eventKey="#tab2"
                >
                  <span className="icon-icon-menu-contact mr-1"></span>
                  <Trans>employee360_competencytestandinterviewresult</Trans>
                </Nav.Link>
              </Nav.Item> */}

              <Nav.Item>
                <Nav.Link
                  onClick={() => this.setState({ currentTab: "#tab3" })}
                  eventKey="#tab3"
                >
                  <span className="iconmford fo-icon-computer mr-1"></span>
                  <Trans>employee360_examresult</Trans>
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  onClick={() => this.setState({ currentTab: "#tab4" })}
                  eventKey="#tab4"
                >
                  <span className="iconmford fo-icon-featured-play-list mr-1"></span>
                  <Trans>employee360_trainigresulstable</Trans>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </nav>

          <Tab.Content>
            {/* <Tab.Pane eventKey="#tab1">
              <CareerPath />
            </Tab.Pane>
            <Tab.Pane eventKey="#tab2">
              <CompetencyAndInterviewResults />
            </Tab.Pane> */}
            <Tab.Pane eventKey="#tab3">
              <ExamResults />
            </Tab.Pane>
            <Tab.Pane eventKey="#tab4">
              <TrainingScores />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    );
  };

  render() {
    return (
      <section className="profilArea my-3">
        {this.props.spinner}
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <Trans desc="Eğitim ve Gelişim">10025</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans>employee360_title</Trans>
                </li>
              </ul>
            </div>
          </div>
          <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <div className="profilBaslik">
                <Trans>employee360_title</Trans>
              </div>
            </div>
          </div>
          <div className="row py-4 bottomRow">{this.renderTabbedContent()}</div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    generalProfile: state.profile.general,
  };
};

export default connect(mapStateToProps, { getProfileGeneral })(
  requireAuth(containsLongRunningProcess(Employee360Container))
);
